import { render, staticRenderFns } from "./CbsDataRefsid.vue?vue&type=template&id=3609ed38&scoped=true"
import script from "./CbsDataRefsid.vue?vue&type=script&lang=js"
export * from "./CbsDataRefsid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3609ed38",
  null
  
)

export default component.exports